"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Accessibility_exports = {};
__export(Accessibility_exports, {
  default: () => Accessibility_default
});
module.exports = __toCommonJS(Accessibility_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M17.1602 6.91016C17.3945 6.91016 17.5898 6.99479 17.7461 7.16406C17.9154 7.32031 18 7.51562 18 7.75C18 7.95833 17.9284 8.14714 17.7852 8.31641C17.6419 8.47266 17.4661 8.55729 17.2578 8.57031L17.1602 8.58984H13V16.9102C13 17.1315 12.9284 17.3203 12.7852 17.4766C12.6419 17.6328 12.4661 17.724 12.2578 17.75H12.1602C11.9518 17.75 11.7695 17.6784 11.6133 17.5352C11.457 17.3919 11.3659 17.2161 11.3398 17.0078V16.9102V12.75H9.66016V16.9102C9.66016 17.1315 9.58854 17.3203 9.44531 17.4766C9.3151 17.6328 9.14583 17.724 8.9375 17.75H8.83984C8.61849 17.75 8.42969 17.6784 8.27344 17.5352C8.11719 17.3919 8.02604 17.2161 8 17.0078V16.9102V8.58984H3.83984C3.60547 8.58984 3.40365 8.51172 3.23438 8.35547C3.07812 8.1862 3 7.98438 3 7.75C3 7.54167 3.07161 7.35938 3.21484 7.20312C3.35807 7.03385 3.53385 6.94271 3.74219 6.92969L3.83984 6.91016H17.1602ZM10.5 2.75C10.9557 2.75 11.3464 2.91276 11.6719 3.23828C11.9974 3.5638 12.1602 3.95443 12.1602 4.41016C12.1602 4.87891 11.9974 5.27604 11.6719 5.60156C11.3464 5.92708 10.9557 6.08984 10.5 6.08984C10.0443 6.08984 9.65365 5.92708 9.32812 5.60156C9.0026 5.27604 8.83984 4.87891 8.83984 4.41016C8.83984 3.95443 9.0026 3.5638 9.32812 3.23828C9.65365 2.91276 10.0443 2.75 10.5 2.75Z",
      fill: "currentColor"
    }
  )
);
const SvgAccessibility = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Accessibility_default = SvgAccessibility;
